var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "container-fluid",
      attrs: { id: "outage-documents-container" },
    },
    [
      _c("loading", {
        attrs: { active: _vm.loading, "can-cancel": false },
        on: {
          "update:active": function ($event) {
            _vm.loading = $event
          },
        },
      }),
      !_vm.data.selected.unit
        ? _c(
            "div",
            {
              staticClass: "alert alert-danger text-center",
              attrs: { role: "alert" },
            },
            [
              _c("h2", { staticClass: "text-danger" }, [
                _vm._v(" " + _vm._s(_vm.$t("pleaseSelectUnit")) + " "),
              ]),
            ]
          )
        : _vm._e(),
      !_vm.data.navBarRefresh && _vm.data.selected.unit
        ? _c("div", { staticClass: "tab-container mt-3" }, [
            _c("h2", { staticClass: "text-center my-3 title" }, [
              _vm._v(" " + _vm._s(_vm.$t("outageDocuments")) + " "),
            ]),
            _c("ul", { staticClass: "tabs" }, [
              _c(
                "li",
                {
                  class: { "tab-active": _vm.tabs.downloadTab.active === true },
                  on: {
                    click: function ($event) {
                      return _vm.toggleTab(_vm.tabs.downloadTab)
                    },
                  },
                },
                [_vm._v(" " + _vm._s(_vm.$t("downloadDocument")) + " ")]
              ),
              _vm.userHasWriteAccessToPlant &&
              _vm.data.selected &&
              _vm.data.selected.unit &&
              !_vm.data.selected.unit.isSubUnit
                ? _c(
                    "li",
                    {
                      class: {
                        "tab-active": _vm.tabs.generateTab.active === true,
                      },
                      on: {
                        click: function ($event) {
                          return _vm.toggleTab(_vm.tabs.generateTab)
                        },
                      },
                    },
                    [
                      _vm._v(
                        " " +
                          _vm._s(
                            _vm.documentSelection.value !==
                              _vm.outageDocumentType.OUTAGE_REPORT &&
                              _vm.documentSelection.value !==
                                _vm.outageDocumentType.RISK_BASED_SCOPING
                              ? _vm.$t("generateDocument")
                              : _vm.$t("uploadDocument")
                          ) +
                          " "
                      ),
                    ]
                  )
                : _vm._e(),
            ]),
            _c("div", { staticClass: "row mt-4 mb-2" }, [
              _c("div", { staticClass: "col-6 input-group input-group-sm" }, [
                _c("div", { staticClass: "input-group-prepend" }, [
                  _c("span", { staticClass: "input-group-text" }, [
                    _vm._v(_vm._s(_vm.$t("document"))),
                  ]),
                ]),
                _c(
                  "select",
                  {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.documentSelection.value,
                        expression: "documentSelection.value",
                      },
                    ],
                    staticClass: "form-control",
                    on: {
                      change: [
                        function ($event) {
                          var $$selectedVal = Array.prototype.filter
                            .call($event.target.options, function (o) {
                              return o.selected
                            })
                            .map(function (o) {
                              var val = "_value" in o ? o._value : o.value
                              return val
                            })
                          _vm.$set(
                            _vm.documentSelection,
                            "value",
                            $event.target.multiple
                              ? $$selectedVal
                              : $$selectedVal[0]
                          )
                        },
                        function ($event) {
                          return _vm.onDocumentTypeSelectionChange()
                        },
                      ],
                    },
                  },
                  [
                    _c(
                      "option",
                      {
                        domProps: {
                          value: _vm.outageDocumentType.SIX_YEARS_OUTAGE_PLAN,
                        },
                      },
                      [_vm._v(" " + _vm._s(_vm.$t("sixYearOutagePlan")) + " ")]
                    ),
                    _c(
                      "option",
                      {
                        domProps: {
                          value: _vm.outageDocumentType.OUTAGE_INITIATION,
                        },
                      },
                      [
                        _vm._v(
                          " " + _vm._s(_vm.$t("outageInitiationDocument")) + " "
                        ),
                      ]
                    ),
                    _c(
                      "option",
                      {
                        domProps: {
                          value: _vm.outageDocumentType.OUTAGE_REPORT,
                        },
                      },
                      [_vm._v(" " + _vm._s(_vm.$t("outageReport")) + " ")]
                    ),
                    _c(
                      "option",
                      {
                        domProps: {
                          value: _vm.outageDocumentType.RISK_BASED_SCOPING,
                        },
                      },
                      [_vm._v(" " + _vm._s(_vm.$t("riskBasedScoping")) + " ")]
                    ),
                  ]
                ),
              ]),
              _vm.documentSelection.value ===
                _vm.outageDocumentType.SIX_YEARS_OUTAGE_PLAN &&
              _vm.tabs.downloadTab.active
                ? _c(
                    "div",
                    { staticClass: "col-6 input-group input-group-sm" },
                    [
                      _c("div", { staticClass: "input-group-prepend" }, [
                        _c("span", { staticClass: "input-group-text" }, [
                          _vm._v(_vm._s(_vm.$t("documentType"))),
                        ]),
                      ]),
                      _c(
                        "select",
                        {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.documentSelection.extension,
                              expression: "documentSelection.extension",
                            },
                          ],
                          staticClass: "form-control",
                          on: {
                            change: function ($event) {
                              var $$selectedVal = Array.prototype.filter
                                .call($event.target.options, function (o) {
                                  return o.selected
                                })
                                .map(function (o) {
                                  var val = "_value" in o ? o._value : o.value
                                  return val
                                })
                              _vm.$set(
                                _vm.documentSelection,
                                "extension",
                                $event.target.multiple
                                  ? $$selectedVal
                                  : $$selectedVal[0]
                              )
                            },
                          },
                        },
                        [
                          _c("option", { attrs: { value: ".pdf" } }, [
                            _vm._v(" PDF "),
                          ]),
                          _c("option", { attrs: { value: ".xlsx" } }, [
                            _vm._v(" Excel "),
                          ]),
                        ]
                      ),
                    ]
                  )
                : _vm._e(),
              _vm.documentSelection.value ===
                _vm.outageDocumentType.OUTAGE_INITIATION ||
              _vm.documentSelection.value ===
                _vm.outageDocumentType.OUTAGE_REPORT ||
              _vm.documentSelection.value ===
                _vm.outageDocumentType.RISK_BASED_SCOPING
                ? _c(
                    "div",
                    { staticClass: "col-6 input-group input-group-sm" },
                    [
                      _c("div", { staticClass: "input-group-prepend" }, [
                        _c("span", { staticClass: "input-group-text" }, [
                          _vm._v(_vm._s(_vm.$t("outageId"))),
                        ]),
                      ]),
                      _c(
                        "select",
                        {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.documentSelection.selectedOutageId,
                              expression: "documentSelection.selectedOutageId",
                            },
                          ],
                          staticClass: "form-control",
                          class: {
                            "is-invalid": _vm.documentSelection.invalidOutageId,
                          },
                          on: {
                            change: [
                              function ($event) {
                                var $$selectedVal = Array.prototype.filter
                                  .call($event.target.options, function (o) {
                                    return o.selected
                                  })
                                  .map(function (o) {
                                    var val = "_value" in o ? o._value : o.value
                                    return val
                                  })
                                _vm.$set(
                                  _vm.documentSelection,
                                  "selectedOutageId",
                                  $event.target.multiple
                                    ? $$selectedVal
                                    : $$selectedVal[0]
                                )
                              },
                              function ($event) {
                                return _vm.onSelectedOutageIdChange()
                              },
                            ],
                          },
                        },
                        [
                          _c("option", { attrs: { value: "" } }),
                          _vm._l(
                            _vm.documentSelection.outageIds,
                            function (outageId, index) {
                              return _c(
                                "option",
                                {
                                  key: "outageId-" + index,
                                  domProps: { value: outageId.id },
                                },
                                [_vm._v(" " + _vm._s(outageId.id) + " ")]
                              )
                            }
                          ),
                        ],
                        2
                      ),
                      _vm.documentSelection.invalidOutageId
                        ? _c("div", { staticClass: "invalid-feedback" }, [
                            _c("span", [
                              _vm._v(_vm._s(_vm.$t("pleaseSelectOutageId"))),
                            ]),
                          ])
                        : _vm._e(),
                    ]
                  )
                : _vm._e(),
            ]),
            _vm.tabs.downloadTab.active
              ? _c("div", [
                  _c("div", { staticClass: "row my-3" }, [
                    _c(
                      "div",
                      { staticClass: "col-12 outage-documents-list-container" },
                      [
                        _c("table", { staticClass: "table table-sm" }, [
                          _c("thead", [
                            _c("tr", { staticClass: "header-row py-2" }, [
                              _c("th", [_vm._v(_vm._s(_vm.$t("name")))]),
                              _vm.documentSelection.value !==
                              _vm.outageDocumentType.SIX_YEARS_OUTAGE_PLAN
                                ? _c("th", [
                                    _vm._v(
                                      " " + _vm._s(_vm.$t("outageId")) + " "
                                    ),
                                  ])
                                : _vm._e(),
                              _vm.documentSelection.value !==
                                _vm.outageDocumentType.OUTAGE_REPORT &&
                              _vm.documentSelection.value !==
                                _vm.outageDocumentType.RISK_BASED_SCOPING
                                ? _c("th", [
                                    _vm._v(
                                      " " + _vm._s(_vm.$t("revisionNo")) + " "
                                    ),
                                  ])
                                : _vm._e(),
                              _c("th", [_vm._v(_vm._s(_vm.$t("date")))]),
                              _vm.documentSelection.value ===
                              _vm.outageDocumentType.SIX_YEARS_OUTAGE_PLAN
                                ? _c("th", { staticClass: "text-capitalize" }, [
                                    _vm._v(" " + _vm._s(_vm.$t("years")) + " "),
                                  ])
                                : _vm._e(),
                              _c("th"),
                            ]),
                          ]),
                          _c(
                            "tbody",
                            { staticClass: "outage-documents-list" },
                            [
                              _vm._l(
                                _vm.outageDocuments,
                                function (document, index) {
                                  return _c(
                                    "tr",
                                    {
                                      directives: [
                                        {
                                          name: "show",
                                          rawName: "v-show",
                                          value:
                                            _vm.outageDocuments &&
                                            _vm.outageDocuments.length,
                                          expression:
                                            "outageDocuments && outageDocuments.length",
                                        },
                                      ],
                                      key: "outageDocument-" + index,
                                      staticClass: "outage-documents-item",
                                    },
                                    [
                                      _c(
                                        "td",
                                        { staticClass: "align-middle" },
                                        [
                                          _vm._v(
                                            " " +
                                              _vm._s(document.originalName) +
                                              " "
                                          ),
                                        ]
                                      ),
                                      _vm.documentSelection.value !==
                                      _vm.outageDocumentType
                                        .SIX_YEARS_OUTAGE_PLAN
                                        ? _c(
                                            "td",
                                            { staticClass: "align-middle" },
                                            [
                                              _vm._v(
                                                " " +
                                                  _vm._s(document.outageId) +
                                                  " "
                                              ),
                                            ]
                                          )
                                        : _vm._e(),
                                      _vm.documentSelection.value !==
                                        _vm.outageDocumentType.OUTAGE_REPORT &&
                                      _vm.documentSelection.value !==
                                        _vm.outageDocumentType
                                          .RISK_BASED_SCOPING
                                        ? _c(
                                            "td",
                                            { staticClass: "align-middle" },
                                            [
                                              _vm._v(
                                                " " +
                                                  _vm._s(
                                                    document.revisionNumber
                                                  ) +
                                                  " "
                                              ),
                                            ]
                                          )
                                        : _vm._e(),
                                      _c(
                                        "td",
                                        { staticClass: "align-middle" },
                                        [
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                _vm._f("dateFormat")(
                                                  new Date(document.freezeDate),
                                                  "YYYY-MM-DD"
                                                )
                                              ) +
                                              " "
                                          ),
                                        ]
                                      ),
                                      _vm.documentSelection.value ===
                                      _vm.outageDocumentType
                                        .SIX_YEARS_OUTAGE_PLAN
                                        ? _c(
                                            "td",
                                            { staticClass: "align-middle" },
                                            [
                                              _vm._v(
                                                " " +
                                                  _vm._s(
                                                    _vm.getSixYearOutagePlanYears(
                                                      document.freezeDate
                                                    )
                                                  ) +
                                                  " "
                                              ),
                                            ]
                                          )
                                        : _vm._e(),
                                      _c(
                                        "td",
                                        {
                                          staticClass:
                                            "text-right align-middle",
                                        },
                                        [
                                          _c(
                                            "button",
                                            {
                                              staticClass:
                                                "btn btn-sm btn-primary",
                                              on: {
                                                click: function ($event) {
                                                  return _vm.downloadDocument(
                                                    document.id
                                                  )
                                                },
                                              },
                                            },
                                            [
                                              _vm._v(
                                                " " +
                                                  _vm._s(_vm.$t("download")) +
                                                  " "
                                              ),
                                            ]
                                          ),
                                        ]
                                      ),
                                    ]
                                  )
                                }
                              ),
                              !_vm.outageDocuments ||
                              !_vm.outageDocuments.length
                                ? _c(
                                    "tr",
                                    { staticClass: "outage-documents-item" },
                                    [
                                      _c(
                                        "td",
                                        {
                                          staticClass:
                                            "text-center text-danger pt-2 pb-2",
                                          attrs: { colspan: "5" },
                                        },
                                        [
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                _vm.$t("noDocumentsFound")
                                              ) +
                                              " "
                                          ),
                                        ]
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                            ],
                            2
                          ),
                        ]),
                      ]
                    ),
                  ]),
                ])
              : _vm._e(),
            _vm.tabs.generateTab.active
              ? _c("div", [
                  _vm.documentSelection.value ===
                    _vm.outageDocumentType.OUTAGE_INITIATION &&
                  _vm.outageDocumentDetails
                    ? _c("div", { staticClass: "row my-3" }, [
                        _c("div", { staticClass: "col-12" }, [
                          _c(
                            "div",
                            {
                              staticClass: "accordion",
                              attrs: {
                                id: "outage-document-details-accordion",
                              },
                            },
                            [
                              _c("div", { staticClass: "card" }, [
                                _c(
                                  "div",
                                  {
                                    staticClass: "card-header p-0",
                                    attrs: { id: "header-area-header" },
                                  },
                                  [
                                    _c(
                                      "button",
                                      {
                                        staticClass:
                                          "btn btn-link btn-block collapsed text-light",
                                        attrs: {
                                          type: "button",
                                          "data-toggle": "collapse",
                                          "data-target":
                                            "#header-area-collapse",
                                          "aria-expanded": "false",
                                          "aria-controls":
                                            "header-area-collapse",
                                        },
                                      },
                                      [
                                        _c(
                                          "h5",
                                          { staticClass: "my-0" },
                                          [
                                            _c("font-awesome-icon", {
                                              staticClass: "mr-1 arrow-up",
                                              attrs: { icon: "chevron-up" },
                                            }),
                                            _c("font-awesome-icon", {
                                              staticClass: "mr-1 arrow-down",
                                              attrs: { icon: "chevron-down" },
                                            }),
                                            _vm._v(" Header Area "),
                                          ],
                                          1
                                        ),
                                      ]
                                    ),
                                  ]
                                ),
                                _c(
                                  "div",
                                  {
                                    staticClass: "collapse",
                                    attrs: {
                                      id: "header-area-collapse",
                                      "aria-labelledby": "header-area-header",
                                      "data-parent":
                                        "#outage-document-details-accordion",
                                    },
                                  },
                                  [
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "card-body p-0 outage-documents-list-container",
                                      },
                                      [
                                        _vm.outageDocumentDetails
                                          .outagePersonnel &&
                                        _vm.outageDocumentDetails
                                          .outagePersonnel.length > 0
                                          ? _c(
                                              "table",
                                              {
                                                staticClass:
                                                  "table table-sm table-bordered mb-0",
                                              },
                                              [
                                                _vm._m(0),
                                                _c("tr", [
                                                  _c("td", [
                                                    _c("input", {
                                                      directives: [
                                                        {
                                                          name: "model",
                                                          rawName: "v-model",
                                                          value:
                                                            _vm
                                                              .outageDocumentDetails
                                                              .preparedBy,
                                                          expression:
                                                            "outageDocumentDetails.preparedBy",
                                                        },
                                                      ],
                                                      staticClass:
                                                        "form-control form-control-sm text-blue",
                                                      attrs: {
                                                        type: "text",
                                                        placeholder:
                                                          "Please fill out this field...",
                                                      },
                                                      domProps: {
                                                        value:
                                                          _vm
                                                            .outageDocumentDetails
                                                            .preparedBy,
                                                      },
                                                      on: {
                                                        input: function (
                                                          $event
                                                        ) {
                                                          if (
                                                            $event.target
                                                              .composing
                                                          ) {
                                                            return
                                                          }
                                                          _vm.$set(
                                                            _vm.outageDocumentDetails,
                                                            "preparedBy",
                                                            $event.target.value
                                                          )
                                                        },
                                                      },
                                                    }),
                                                  ]),
                                                  _c(
                                                    "td",
                                                    {
                                                      staticClass:
                                                        "align-middle",
                                                    },
                                                    [
                                                      _vm._v(
                                                        " " +
                                                          _vm._s(
                                                            _vm
                                                              .outageDocumentDetails
                                                              .currentDate
                                                          ) +
                                                          " "
                                                      ),
                                                    ]
                                                  ),
                                                ]),
                                              ]
                                            )
                                          : _vm._e(),
                                        _vm.outageDocumentDetails
                                          .outagePersonnel &&
                                        _vm.outageDocumentDetails
                                          .outagePersonnel.length > 0
                                          ? _c(
                                              "table",
                                              {
                                                staticClass:
                                                  "table table-sm table-bordered mb-0",
                                              },
                                              [
                                                _c("tr", [
                                                  _c(
                                                    "td",
                                                    {
                                                      staticClass:
                                                        "align-middle font-weight-bold width-20",
                                                      attrs: { rowspan: "2" },
                                                    },
                                                    [
                                                      _vm._v(
                                                        " Scope (Outage Title) "
                                                      ),
                                                    ]
                                                  ),
                                                  _c(
                                                    "td",
                                                    {
                                                      staticClass:
                                                        "align-middle",
                                                      attrs: { rowspan: "2" },
                                                    },
                                                    [
                                                      _c(
                                                        "h4",
                                                        { staticClass: "my-0" },
                                                        [
                                                          _c("i", [
                                                            _vm._v(
                                                              _vm._s(
                                                                _vm
                                                                  .outageDocumentDetails
                                                                  .outageTitle
                                                              )
                                                            ),
                                                          ]),
                                                        ]
                                                      ),
                                                    ]
                                                  ),
                                                  _vm._m(1),
                                                ]),
                                                _c("tr", [
                                                  _c("td", [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm
                                                          .outageDocumentDetails
                                                          .scopeFreezeDate
                                                      )
                                                    ),
                                                  ]),
                                                ]),
                                              ]
                                            )
                                          : _vm._e(),
                                        _vm.outageDocumentDetails
                                          .outagePersonnel &&
                                        _vm.outageDocumentDetails
                                          .outagePersonnel.length > 0
                                          ? _c(
                                              "table",
                                              {
                                                staticClass:
                                                  "table table-sm table-bordered mb-0",
                                              },
                                              [
                                                _vm._m(2),
                                                _c("tr", [
                                                  _c("td", [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm
                                                          .outageDocumentDetails
                                                          .unitCapacity
                                                      )
                                                    ),
                                                  ]),
                                                  _c("td", [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm
                                                          .outageDocumentDetails
                                                          .year
                                                      )
                                                    ),
                                                  ]),
                                                  _c("td", [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm
                                                          .outageDocumentDetails
                                                          .startDate
                                                      )
                                                    ),
                                                  ]),
                                                  _c("td", [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm
                                                          .outageDocumentDetails
                                                          .endDate
                                                      )
                                                    ),
                                                  ]),
                                                  _c("td", [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm
                                                          .outageDocumentDetails
                                                          .duration
                                                      )
                                                    ),
                                                  ]),
                                                  _c("td", [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm
                                                          .outageDocumentDetails
                                                          .lostGeneration
                                                      )
                                                    ),
                                                  ]),
                                                ]),
                                                _c("tr", [
                                                  _c(
                                                    "td",
                                                    {
                                                      staticClass:
                                                        "align-middle font-weight-bold width-10",
                                                    },
                                                    [_vm._v(" Business Case ")]
                                                  ),
                                                  _c(
                                                    "td",
                                                    { attrs: { colspan: "6" } },
                                                    [
                                                      _vm._v(
                                                        " " +
                                                          _vm._s(
                                                            _vm
                                                              .outageDocumentDetails
                                                              .businessCase
                                                          ) +
                                                          " "
                                                      ),
                                                    ]
                                                  ),
                                                ]),
                                                _c("tr", [
                                                  _c(
                                                    "td",
                                                    {
                                                      staticClass:
                                                        "align-middle font-weight-bold width-10",
                                                    },
                                                    [_vm._v(" Main Objective ")]
                                                  ),
                                                  _c(
                                                    "td",
                                                    { attrs: { colspan: "6" } },
                                                    [
                                                      _c("textarea", {
                                                        directives: [
                                                          {
                                                            name: "model",
                                                            rawName: "v-model",
                                                            value:
                                                              _vm
                                                                .outageDocumentDetails
                                                                .mainObjective,
                                                            expression:
                                                              "outageDocumentDetails.mainObjective",
                                                          },
                                                        ],
                                                        staticClass:
                                                          "form-control form-control-sm text-blue",
                                                        attrs: {
                                                          rows: "3",
                                                          placeholder:
                                                            "Please fill out this field...",
                                                        },
                                                        domProps: {
                                                          value:
                                                            _vm
                                                              .outageDocumentDetails
                                                              .mainObjective,
                                                        },
                                                        on: {
                                                          input: function (
                                                            $event
                                                          ) {
                                                            if (
                                                              $event.target
                                                                .composing
                                                            ) {
                                                              return
                                                            }
                                                            _vm.$set(
                                                              _vm.outageDocumentDetails,
                                                              "mainObjective",
                                                              $event.target
                                                                .value
                                                            )
                                                          },
                                                        },
                                                      }),
                                                    ]
                                                  ),
                                                ]),
                                              ]
                                            )
                                          : _vm._e(),
                                      ]
                                    ),
                                  ]
                                ),
                              ]),
                              _c("div", { staticClass: "card mt-2" }, [
                                _c(
                                  "div",
                                  {
                                    staticClass: "card-header p-0",
                                    attrs: { id: "scope-area-header" },
                                  },
                                  [
                                    _c(
                                      "button",
                                      {
                                        staticClass:
                                          "btn btn-link btn-block collapsed text-light",
                                        attrs: {
                                          type: "button",
                                          "data-toggle": "collapse",
                                          "data-target": "#scope-area-collapse",
                                          "aria-expanded": "false",
                                          "aria-controls":
                                            "scope-area-collapse",
                                        },
                                      },
                                      [
                                        _c(
                                          "h5",
                                          { staticClass: "my-0" },
                                          [
                                            _c("font-awesome-icon", {
                                              staticClass: "mr-1 arrow-up",
                                              attrs: { icon: "chevron-up" },
                                            }),
                                            _c("font-awesome-icon", {
                                              staticClass: "mr-1 arrow-down",
                                              attrs: { icon: "chevron-down" },
                                            }),
                                            _vm._v(
                                              " Scope (Key Deliverables) Area "
                                            ),
                                          ],
                                          1
                                        ),
                                      ]
                                    ),
                                  ]
                                ),
                                _vm._m(3),
                              ]),
                              _c("div", { staticClass: "card mt-2" }, [
                                _c(
                                  "div",
                                  {
                                    staticClass: "card-header p-0",
                                    attrs: { id: "risk-details-header" },
                                  },
                                  [
                                    _c(
                                      "button",
                                      {
                                        staticClass:
                                          "btn btn-link btn-block collapsed text-light",
                                        attrs: {
                                          type: "button",
                                          "data-toggle": "collapse",
                                          "data-target":
                                            "#risk-details-collapse",
                                          "aria-expanded": "false",
                                          "aria-controls":
                                            "risk-details-collapse",
                                        },
                                      },
                                      [
                                        _c(
                                          "h5",
                                          { staticClass: "my-0" },
                                          [
                                            _c("font-awesome-icon", {
                                              staticClass: "mr-1 arrow-up",
                                              attrs: { icon: "chevron-up" },
                                            }),
                                            _c("font-awesome-icon", {
                                              staticClass: "mr-1 arrow-down",
                                              attrs: { icon: "chevron-down" },
                                            }),
                                            _vm._v(" Risk Area "),
                                          ],
                                          1
                                        ),
                                      ]
                                    ),
                                  ]
                                ),
                                _c(
                                  "div",
                                  {
                                    staticClass: "collapse",
                                    attrs: {
                                      id: "risk-details-collapse",
                                      "aria-labelledby": "risk-details-header",
                                      "data-parent":
                                        "#outage-document-details-accordion",
                                    },
                                  },
                                  [
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "card-body p-0 outage-documents-list-container",
                                      },
                                      [
                                        _vm.outageDocumentDetails.riskDetails &&
                                        _vm.outageDocumentDetails.riskDetails
                                          .length > 0
                                          ? _c(
                                              "table",
                                              { staticClass: "table mb-0" },
                                              [
                                                _vm._m(4),
                                                _c(
                                                  "tbody",
                                                  {
                                                    staticClass:
                                                      "outage-documents-list",
                                                  },
                                                  _vm._l(
                                                    _vm.outageDocumentDetails
                                                      .riskDetails,
                                                    function (
                                                      riskDetails,
                                                      index
                                                    ) {
                                                      return _c(
                                                        "tr",
                                                        {
                                                          key:
                                                            "riskDetail-" +
                                                            index,
                                                          staticClass:
                                                            "outage-documents-item",
                                                        },
                                                        [
                                                          _c("td", [
                                                            _vm._v(
                                                              _vm._s(
                                                                riskDetails.riskAreaDescription
                                                              )
                                                            ),
                                                          ]),
                                                          _c("td", [
                                                            _c("textarea", {
                                                              directives: [
                                                                {
                                                                  name: "model",
                                                                  rawName:
                                                                    "v-model",
                                                                  value:
                                                                    riskDetails.specificOutageDeliveryRisk,
                                                                  expression:
                                                                    "riskDetails.specificOutageDeliveryRisk",
                                                                },
                                                              ],
                                                              staticClass:
                                                                "form-control form-control-sm",
                                                              attrs: {
                                                                rows: "3",
                                                                type: "text",
                                                              },
                                                              domProps: {
                                                                value:
                                                                  riskDetails.specificOutageDeliveryRisk,
                                                              },
                                                              on: {
                                                                input:
                                                                  function (
                                                                    $event
                                                                  ) {
                                                                    if (
                                                                      $event
                                                                        .target
                                                                        .composing
                                                                    ) {
                                                                      return
                                                                    }
                                                                    _vm.$set(
                                                                      riskDetails,
                                                                      "specificOutageDeliveryRisk",
                                                                      $event
                                                                        .target
                                                                        .value
                                                                    )
                                                                  },
                                                              },
                                                            }),
                                                          ]),
                                                          _c("td", [
                                                            _c(
                                                              "select",
                                                              {
                                                                directives: [
                                                                  {
                                                                    name: "model",
                                                                    rawName:
                                                                      "v-model",
                                                                    value:
                                                                      riskDetails.impact,
                                                                    expression:
                                                                      "riskDetails.impact",
                                                                  },
                                                                ],
                                                                staticClass:
                                                                  "form-control form-control-sm",
                                                                on: {
                                                                  change:
                                                                    function (
                                                                      $event
                                                                    ) {
                                                                      var $$selectedVal =
                                                                        Array.prototype.filter
                                                                          .call(
                                                                            $event
                                                                              .target
                                                                              .options,
                                                                            function (
                                                                              o
                                                                            ) {
                                                                              return o.selected
                                                                            }
                                                                          )
                                                                          .map(
                                                                            function (
                                                                              o
                                                                            ) {
                                                                              var val =
                                                                                "_value" in
                                                                                o
                                                                                  ? o._value
                                                                                  : o.value
                                                                              return val
                                                                            }
                                                                          )
                                                                      _vm.$set(
                                                                        riskDetails,
                                                                        "impact",
                                                                        $event
                                                                          .target
                                                                          .multiple
                                                                          ? $$selectedVal
                                                                          : $$selectedVal[0]
                                                                      )
                                                                    },
                                                                },
                                                              },
                                                              _vm._l(
                                                                _vm.outageRiskDetailLevels,
                                                                function (
                                                                  level,
                                                                  rIndex
                                                                ) {
                                                                  return _c(
                                                                    "option",
                                                                    {
                                                                      key:
                                                                        "impactLevel-" +
                                                                        rIndex,
                                                                    },
                                                                    [
                                                                      _vm._v(
                                                                        " " +
                                                                          _vm._s(
                                                                            level
                                                                          ) +
                                                                          " "
                                                                      ),
                                                                    ]
                                                                  )
                                                                }
                                                              ),
                                                              0
                                                            ),
                                                          ]),
                                                          _c("td", [
                                                            _c(
                                                              "select",
                                                              {
                                                                directives: [
                                                                  {
                                                                    name: "model",
                                                                    rawName:
                                                                      "v-model",
                                                                    value:
                                                                      riskDetails.likelihood,
                                                                    expression:
                                                                      "riskDetails.likelihood",
                                                                  },
                                                                ],
                                                                staticClass:
                                                                  "form-control form-control-sm",
                                                                on: {
                                                                  change:
                                                                    function (
                                                                      $event
                                                                    ) {
                                                                      var $$selectedVal =
                                                                        Array.prototype.filter
                                                                          .call(
                                                                            $event
                                                                              .target
                                                                              .options,
                                                                            function (
                                                                              o
                                                                            ) {
                                                                              return o.selected
                                                                            }
                                                                          )
                                                                          .map(
                                                                            function (
                                                                              o
                                                                            ) {
                                                                              var val =
                                                                                "_value" in
                                                                                o
                                                                                  ? o._value
                                                                                  : o.value
                                                                              return val
                                                                            }
                                                                          )
                                                                      _vm.$set(
                                                                        riskDetails,
                                                                        "likelihood",
                                                                        $event
                                                                          .target
                                                                          .multiple
                                                                          ? $$selectedVal
                                                                          : $$selectedVal[0]
                                                                      )
                                                                    },
                                                                },
                                                              },
                                                              _vm._l(
                                                                _vm.outageRiskDetailLevels,
                                                                function (
                                                                  level,
                                                                  lIndex
                                                                ) {
                                                                  return _c(
                                                                    "option",
                                                                    {
                                                                      key:
                                                                        "likelihoodLevel-" +
                                                                        lIndex,
                                                                    },
                                                                    [
                                                                      _vm._v(
                                                                        " " +
                                                                          _vm._s(
                                                                            level
                                                                          ) +
                                                                          " "
                                                                      ),
                                                                    ]
                                                                  )
                                                                }
                                                              ),
                                                              0
                                                            ),
                                                          ]),
                                                          _c("td", [
                                                            _c("textarea", {
                                                              directives: [
                                                                {
                                                                  name: "model",
                                                                  rawName:
                                                                    "v-model",
                                                                  value:
                                                                    riskDetails.mitigation,
                                                                  expression:
                                                                    "riskDetails.mitigation",
                                                                },
                                                              ],
                                                              staticClass:
                                                                "form-control form-control-sm",
                                                              attrs: {
                                                                rows: "3",
                                                                type: "text",
                                                              },
                                                              domProps: {
                                                                value:
                                                                  riskDetails.mitigation,
                                                              },
                                                              on: {
                                                                input:
                                                                  function (
                                                                    $event
                                                                  ) {
                                                                    if (
                                                                      $event
                                                                        .target
                                                                        .composing
                                                                    ) {
                                                                      return
                                                                    }
                                                                    _vm.$set(
                                                                      riskDetails,
                                                                      "mitigation",
                                                                      $event
                                                                        .target
                                                                        .value
                                                                    )
                                                                  },
                                                              },
                                                            }),
                                                          ]),
                                                        ]
                                                      )
                                                    }
                                                  ),
                                                  0
                                                ),
                                              ]
                                            )
                                          : _vm._e(),
                                      ]
                                    ),
                                  ]
                                ),
                              ]),
                              _c("div", { staticClass: "card mt-2" }, [
                                _c(
                                  "div",
                                  {
                                    staticClass: "card-header p-0",
                                    attrs: { id: "signature-area-header" },
                                  },
                                  [
                                    _c(
                                      "button",
                                      {
                                        staticClass:
                                          "btn btn-link btn-block collapsed text-light",
                                        attrs: {
                                          type: "button",
                                          "data-toggle": "collapse",
                                          "data-target":
                                            "#signature-area-collapse",
                                          "aria-expanded": "false",
                                          "aria-controls":
                                            "signature-area-collapse",
                                        },
                                      },
                                      [
                                        _c(
                                          "h5",
                                          { staticClass: "my-0" },
                                          [
                                            _c("font-awesome-icon", {
                                              staticClass: "mr-1 arrow-up",
                                              attrs: { icon: "chevron-up" },
                                            }),
                                            _c("font-awesome-icon", {
                                              staticClass: "mr-1 arrow-down",
                                              attrs: { icon: "chevron-down" },
                                            }),
                                            _vm._v(" Signature Area "),
                                          ],
                                          1
                                        ),
                                      ]
                                    ),
                                  ]
                                ),
                                _c(
                                  "div",
                                  {
                                    staticClass: "collapse",
                                    attrs: {
                                      id: "signature-area-collapse",
                                      "aria-labelledby":
                                        "signature-area-header",
                                      "data-parent":
                                        "#outage-document-details-accordion",
                                    },
                                  },
                                  [
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "card-body p-0 outage-documents-list-container",
                                      },
                                      [
                                        _vm.outageDocumentDetails
                                          .outagePersonnel &&
                                        _vm.outageDocumentDetails
                                          .outagePersonnel.length > 0
                                          ? _c(
                                              "table",
                                              { staticClass: "table mb-0" },
                                              [
                                                _c("thead", [
                                                  _c(
                                                    "tr",
                                                    {
                                                      staticClass:
                                                        "table-primary",
                                                    },
                                                    [
                                                      _c("th", {
                                                        staticClass: "width-10",
                                                      }),
                                                      _c("th", [
                                                        _vm._v(
                                                          _vm._s(_vm.$t("name"))
                                                        ),
                                                      ]),
                                                      _c(
                                                        "th",
                                                        {
                                                          staticClass:
                                                            "width-10",
                                                        },
                                                        [
                                                          _vm._v(
                                                            " " +
                                                              _vm._s(
                                                                _vm.$t("date")
                                                              ) +
                                                              " "
                                                          ),
                                                        ]
                                                      ),
                                                    ]
                                                  ),
                                                ]),
                                                _c(
                                                  "tbody",
                                                  {
                                                    staticClass:
                                                      "outage-documents-list",
                                                  },
                                                  _vm._l(
                                                    _vm.outageDocumentDetails
                                                      .outagePersonnel,
                                                    function (
                                                      personnel,
                                                      index
                                                    ) {
                                                      return _c(
                                                        "tr",
                                                        {
                                                          key:
                                                            "outagePersonnel-" +
                                                            index,
                                                          staticClass:
                                                            "outage-documents-item",
                                                        },
                                                        [
                                                          _c("td", [
                                                            _vm._v(
                                                              _vm._s(
                                                                personnel.roleDescription
                                                              )
                                                            ),
                                                          ]),
                                                          _c("td", [
                                                            _c("input", {
                                                              directives: [
                                                                {
                                                                  name: "model",
                                                                  rawName:
                                                                    "v-model",
                                                                  value:
                                                                    personnel.name,
                                                                  expression:
                                                                    "personnel.name",
                                                                },
                                                              ],
                                                              staticClass:
                                                                "form-control form-control-sm",
                                                              attrs: {
                                                                type: "text",
                                                              },
                                                              domProps: {
                                                                value:
                                                                  personnel.name,
                                                              },
                                                              on: {
                                                                input:
                                                                  function (
                                                                    $event
                                                                  ) {
                                                                    if (
                                                                      $event
                                                                        .target
                                                                        .composing
                                                                    ) {
                                                                      return
                                                                    }
                                                                    _vm.$set(
                                                                      personnel,
                                                                      "name",
                                                                      $event
                                                                        .target
                                                                        .value
                                                                    )
                                                                  },
                                                              },
                                                            }),
                                                          ]),
                                                          _c(
                                                            "td",
                                                            [
                                                              _c(
                                                                "date-picker",
                                                                {
                                                                  attrs: {
                                                                    type: "date",
                                                                    "value-type":
                                                                      "format",
                                                                    format:
                                                                      "YYYY-MM-DD",
                                                                    "input-class":
                                                                      "form-control form-control-sm",
                                                                  },
                                                                  model: {
                                                                    value:
                                                                      personnel.date,
                                                                    callback:
                                                                      function (
                                                                        $$v
                                                                      ) {
                                                                        _vm.$set(
                                                                          personnel,
                                                                          "date",
                                                                          $$v
                                                                        )
                                                                      },
                                                                    expression:
                                                                      "personnel.date",
                                                                  },
                                                                }
                                                              ),
                                                            ],
                                                            1
                                                          ),
                                                        ]
                                                      )
                                                    }
                                                  ),
                                                  0
                                                ),
                                              ]
                                            )
                                          : _vm._e(),
                                      ]
                                    ),
                                  ]
                                ),
                              ]),
                            ]
                          ),
                        ]),
                      ])
                    : _vm._e(),
                  _vm.documentSelection.value ===
                    _vm.outageDocumentType.OUTAGE_REPORT ||
                  _vm.documentSelection.value ===
                    _vm.outageDocumentType.RISK_BASED_SCOPING
                    ? _c("div", { staticClass: "row my-3" }, [
                        _c("div", { staticClass: "col-12" }, [
                          _c("div", { staticClass: "input-group" }, [
                            _c("div", { staticClass: "input-group-prepend" }, [
                              _c("span", { staticClass: "input-group-text" }, [
                                _vm._v(_vm._s(_vm.$t("uploadDocument"))),
                              ]),
                            ]),
                            _c("div", { staticClass: "custom-file" }, [
                              _c("input", {
                                ref: "fileToUpload",
                                staticClass: "custom-file-input",
                                class: {
                                  "is-invalid": _vm.noDocumentSelectedForUpload,
                                },
                                attrs: { type: "file", id: "inputGroupFile" },
                                on: {
                                  change: function ($event) {
                                    return _vm.setUploadedFileName($event)
                                  },
                                },
                              }),
                              _c(
                                "label",
                                {
                                  staticClass: "custom-file-label",
                                  attrs: { for: "inputGroupFile" },
                                },
                                [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm.uploadedFileName ||
                                          _vm.$t("chooseFile")
                                      ) +
                                      " "
                                  ),
                                ]
                              ),
                            ]),
                          ]),
                          _vm.noDocumentSelectedForUpload
                            ? _c(
                                "div",
                                { staticClass: "invalid-feedback d-block" },
                                [
                                  _c("span", [
                                    _vm._v(
                                      _vm._s(_vm.$t("pleaseSelectDocument"))
                                    ),
                                  ]),
                                ]
                              )
                            : _vm._e(),
                        ]),
                      ])
                    : _vm._e(),
                  _c("div", { staticClass: "row my-3" }, [
                    _c("div", { staticClass: "col-12" }, [
                      _c(
                        "button",
                        {
                          staticClass: "btn btn-sm btn-primary",
                          on: {
                            click: function ($event) {
                              return _vm.generateDocument()
                            },
                          },
                        },
                        [
                          _vm._v(
                            " " +
                              _vm._s(
                                _vm.documentSelection.value !==
                                  _vm.outageDocumentType.OUTAGE_REPORT &&
                                  _vm.documentSelection.value !==
                                    _vm.outageDocumentType.RISK_BASED_SCOPING
                                  ? _vm.$t("generateDocument")
                                  : _vm.$t("uploadDocument")
                              ) +
                              " "
                          ),
                        ]
                      ),
                      _vm.documentSelection.value ===
                        _vm.outageDocumentType.OUTAGE_INITIATION &&
                      _vm.outageDocumentDetails
                        ? _c(
                            "button",
                            {
                              staticClass: "btn btn-sm btn-success ml-2",
                              on: {
                                click: function ($event) {
                                  return _vm.saveData()
                                },
                              },
                            },
                            [_vm._v(" " + _vm._s(_vm.$t("save")) + " ")]
                          )
                        : _vm._e(),
                    ]),
                  ]),
                ])
              : _vm._e(),
          ])
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("tr", [
      _c(
        "td",
        {
          staticClass: "table-primary text-center align-middle",
          attrs: { rowspan: "2" },
        },
        [
          _c("h4", { staticClass: "my-0" }, [
            _vm._v(" Outage Initiation Document - 3 yrs prior "),
          ]),
        ]
      ),
      _c("td", { staticClass: "width-20" }, [
        _c("small", [_vm._v("Prepared By / Initiator:")]),
      ]),
      _c("td", { staticClass: "width-10" }, [_c("small", [_vm._v("Date:")])]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("td", { staticClass: "width-10" }, [
      _c("small", [_vm._v("Scope Freeze Date:")]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("tr", [
      _c(
        "td",
        {
          staticClass: "align-middle font-weight-bold width-10",
          attrs: { rowspan: "2" },
        },
        [_vm._v(" Schedule ")]
      ),
      _c("td", [_c("small", [_vm._v("Generation Unit / Capacity:")])]),
      _c("td", [_c("small", [_vm._v("Year:")])]),
      _c("td", [_c("small", [_vm._v("Target Start Date:")])]),
      _c("td", [_c("small", [_vm._v("Target End Date:")])]),
      _c("td", [_c("small", [_vm._v("Target Duration:")])]),
      _c("td", [_c("small", [_vm._v("Lost Generation: GWh")])]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticClass: "collapse",
        attrs: {
          id: "scope-area-collapse",
          "aria-labelledby": "scope-area-header",
          "data-parent": "#outage-document-details-accordion",
        },
      },
      [
        _c("div", { staticClass: "card-body p-2" }, [
          _vm._v(" This area is generated automatically by the tool. "),
        ]),
      ]
    )
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("thead", [
      _c("tr", { staticClass: "table-primary" }, [
        _c("th", { staticClass: "width-10" }, [_vm._v(" Risk Area ")]),
        _c("th", { staticClass: "width-30" }, [
          _vm._v(" Specific Outage Delivery Risk "),
        ]),
        _c("th", { staticClass: "width-10" }, [_vm._v(" Impact ")]),
        _c("th", { staticClass: "width-10" }, [_vm._v(" Likelihood ")]),
        _c("th", { staticClass: "width-30" }, [_vm._v(" Mitigation ")]),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }